// extracted by mini-css-extract-plugin
export default {"charts":"VerificationStatisticCharts_charts__Xcu3P","charts__block":"VerificationStatisticCharts_charts__block__vyIP3"};